export default __webpack_public_path__ + "static/media/RobotoSlab-Bold.c45cfba4.ttf";